module.exports = __webpack_public_path__ + "img/Avatar-32.aaf0ccaa.svg";